import { Observable, map } from 'rxjs';
import { Injectable } from '@angular/core';

import { Consent } from '../entities/consent.entity';
import { WebApiService } from './web-api.service';

@Injectable({
  providedIn: 'root',
})
export class ConsentService {
  private readonly CONSENT_PATH = '/api/v1.1/consent';
  private readonly MANY_CONSENTS_PATH = '/api/v1.1/consent/many';

  constructor(private webApiService: WebApiService) {}

  /**
   * Gets all consents of logged user
   * @returns observable with consents array
   */
  public getAll(): Observable<Consent[]> {
    return this.webApiService
      .get(this.CONSENT_PATH)
      .pipe(
        map((response) =>
          response.data.map((item) => new Consent().deserialize(item))
        )
      );
  }

  /**
   * Gets one consent of logged user
   * @param id
   * @returns observable with consent
   */
  public getConsent(id: string): Observable<Consent> {
    console.log('🚀 ~ ConsentService ~ getConsent ~ getConsent:');

    return this.webApiService
      .get(this.CONSENT_PATH + '/' + id)
      .pipe(map((response) => new Consent().deserialize(response.data)));
  }

  /**
   * Creates consent
   * @param data
   * @returns observable with created consent id
   */
  public postConsent(data: any = {}): Observable<string> {
    return this.webApiService
      .post(this.CONSENT_PATH, data)
      .pipe(map((response) => response.data));
  }

  /**
   * Creates many consents once
   * @param data
   * @returns observable with consent ids array
   */
  public postManyConsents(data: any[] = []): Observable<string[]> {
    return this.webApiService
      .post(this.MANY_CONSENTS_PATH, data)
      .pipe(map((response) => response.data));
  }
}
